import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
declare let $: any;
declare let Swiper: any;
declare let bootstrap: any;
import * as CryptoJS from 'crypto-js';
import { EncryptDecryptService } from 'src/app/headquarter/service/encrypt-decrypt.service';
import { fciWebsiteService } from 'src/app/headquarter/service/fci-website.service';
import { environment } from 'src/environments/environment';
import { Buffer } from 'buffer';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-landing-carousel',
  templateUrl: './landing-carousel.component.html',
  styleUrls: ['./landing-carousel.component.css'],
})
export class LandingCarouselComponent implements OnInit {
  language: any = '';
  constructor(
    private fciwebservice: fciWebsiteService,
    private routerparam: ActivatedRoute,
    private route: Router,
    public encDec: EncryptDecryptService,
    public translate: TranslateService
  ) {}
  bannerResult: any = [];
  backendUrl = environment.serviceURL;
  CURRENT_ZONE_ID: any = environment.ZONE_ID;
  CURRENT_REGION_ID: any = environment.REGION_ID;
  CURRENT_ZONE_CODE: any = environment.ZONE_CODE;
  CURRENT_REGION_CODE: any = environment.REGION_CODE;
  ngOnInit(): void {
    this.language = sessionStorage.getItem('locale'); //dynamic content language translation
    this.getCarousl();
    // FOR LANDING SWIPER CAROUSEL - STARTS
    let swiper = new Swiper('.thumbnails', {
      spaceBetween: 0,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,
      runCallbacksOnInit: true,
    });
    let swiper2 = new Swiper('.main-slider', {
      effect: 'fade',
      speed: 800,
      spaceBetween: 10,
      autoplay: {
        delay: 8000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      thumbs: {
        swiper: swiper,
      },
      runCallbacksOnInit: true,
    });
    // FOR LANDING SWIPER CAROUSEL - ENDS
  }
  getCarousl() {
    let query: any = [];
    query = [
      {
        columnName: 'tinPublishStatus',
        operator: '=',
        value: '1',
        joinoperator: '',
      },
      {
        columnName: 'bitDeletedFlag',
        operator: '=',
        value: '0',
        joinoperator: '',
      },
    ];
    if (environment.ZONE_ID > 0) {
      query.push({
        columnName: 'ZONE_ID',
        operator: '=',
        value: environment.ZONE_ID,
        joinoperator: 'and',
      });
    }
    let carouselData: any = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 0,
        orderBy: [{ columnName: 'INTSLNO', type: 'ASC' }],
        condition: query,
        viewParameters: '',
      },
    ];
    this.fciwebservice
      .getAll(carouselData, 'ManageBanner')
      .subscribe((resp: any) => {
        let respData = resp.RESPONSE_DATA;
        let respToken = resp.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(
          respData,
          environment.apiHashingKey
        ).toString();

        if (respToken == verifyToken) {
          let response: any = Buffer.from(respData, 'base64');
          response = JSON.parse(response.toString());
          if (response.status == 200) {
            this.bannerResult = response['result']['sec_1'];
          }
        }
      });
  }
  goToContentPage(menuid: any) {
    let params = [
      {
        secSlNo: 1,
        offSet: 0,
        noOfRecords: 0,
        orderBy: [],
        condition: [
          {
            columnName: 'tinPublishStatus',
            operator: '=',
            value: '1',
            joinoperator: 'and',
          },
          {
            columnName: 'bitDeletedFlag',
            operator: '=',
            value: 0,
            joinoperator: 'and',
          },
          {
            columnName: 'intId',
            operator: '=',
            value: menuid,
            joinoperator: 'and',
          },
        ],
        viewParameters: '',
      },
    ];
    this.fciwebservice.getAll(params, 'ManageMenu').subscribe((resp: any) => {
      let respData = resp.RESPONSE_DATA;
      let respToken = resp.RESPONSE_TOKEN;

      let verifyToken = CryptoJS.HmacSHA256(
        respData,
        environment.apiHashingKey
      ).toString();
      if (respToken == verifyToken) {
        let response: any = Buffer.from(respData, 'base64');
        response = JSON.parse(response.toString());
        if (response.status == 200) {
          if (response.result.sec_1.length > 0) {
            const linkType = response.result.sec_1[0].linkType;
            switch (linkType) {
              case 1: //external page
                this.goToExtLink(response.result.sec_1[0].externalLink);
                break;
              case 2: //plugin page
                this.goToPluginPage(response.result.sec_1[0].selectPlugin, {
                  plugin_id: response.result.sec_1[0].id,
                  selectPlugin: response.result.sec_1[0].selectPlugin,
                });
                break;
              case 3: //content page
                this.setSelectedData(response.result.sec_1[0]);
                break;
              case 4: //na
                break;
              default:
              //
            }
          }
        }
      }
    });
  }

  getJsonOptTxtDetails(jsonOptTxtDetails: any, columnName: any) {
    let parsedJsonData: any = JSON.parse(jsonOptTxtDetails);
    return parsedJsonData[columnName];
  }

  getMenuname(jsonOptTxtDetails: any, columnName: any) {
    let parsedJsonData: any = JSON.parse(jsonOptTxtDetails);
    if (this.language == 'English') {
      return parsedJsonData[columnName];
    } else {
      if (parsedJsonData[columnName] == 'About Us') {
        return 'हमारे बारे में';
      } else if (parsedJsonData[columnName] == 'Movement') {
        return 'परिचालन';
      } else if (parsedJsonData[columnName] == 'Procurement') {
        return 'अधिप्राप्ति';
      } else if (parsedJsonData[columnName] == 'Storage') {
        return 'भंडारण';
      } else if (parsedJsonData[columnName] == 'Sales') {
        return 'बिक्री';
      }
      return parsedJsonData[columnName];
    }
  }

  goToPluginPage(link: any, menudtl: any) {
    sessionStorage.removeItem(btoa(menudtl.selectPlugin));
    sessionStorage.setItem(btoa(menudtl.selectPlugin), JSON.stringify(menudtl));
    this.route
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.route.navigate([link]));
  }

  goToExtLink(url: any) {
    Swal.fire({
      title:
        'You are being redirected to an external website. Please note that Food Corporation of India (FCI) cannot be held responsible for external websites content & privacy policies.',
      text: 'Are you sure?',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      if (result.value) {
        window.open(url, '_blank');
      }
    });
  }

  setSelectedData(response: any) {
    this.route
      .navigateByUrl('/', { skipLocationChange: true })
      .then(() => this.route.navigate(['./view' + '/' + response.menuAlias]));
  }
}
